import { render, staticRenderFns } from "./PDFLoader534.vue?vue&type=template&id=65db675e&scoped=true&"
import script from "./PDFLoader534.vue?vue&type=script&lang=ts&"
export * from "./PDFLoader534.vue?vue&type=script&lang=ts&"
import style0 from "./PDFLoader534.vue?vue&type=style&index=0&id=65db675e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db675e",
  null
  
)

export default component.exports